import React, {useEffect, useState} from "react";
import SelectField from "../SelectField";
import {useSelector} from "react-redux";
import {apiGetTurnstile} from "../../pages/ENIGOOTurnstiles/Turnstiles/Actions";

const ApiTurnstileSelectField = ({
                                     disabled = false,
                                     isMulti = true,
                                     onChange = null,
                                     isMandatory = false,
                                     onEnter = null,
                                     name = "turnstile",
                                     withoutIds = [],
                                     label = "Turniket"
                                 }) => {

    let [data, setData] = useState([]);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user)


    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal])

    const getData = () => {
        setLoading(true);
        apiGetTurnstile(user.activeAreal.id, null, (data) => {
            setData(data.turnstile ? data.turnstile : []);
            setLoading(false);
        }, (error) => {
            setData([]);
            setLoading(false);
        })
    }

    const getOptions = () => {
        let options = [];
        if(data){
            data.map((item, index) => {
                if (!withoutIds || !withoutIds.includes(item.id)) {
                    options.push({label: <div>{item.description} <sup>({item.ipAddress})</sup></div>, value: item.id})
                }
            })
        }
        return options;
    }
    if (isMulti) {
        return (
            <SelectField onEnter={onEnter} isMandatory={isMandatory} disabled={disabled}
                         placeholder={loading ? "Načítám data.." : "Turniket"} name={name}
                         options={loading ? [] : getOptions()} label={label === "Turniket" ? "Turnikety" : label}
                         isMulti={true} onChange={onChange}/>
        )
    } else {
        return (
            <SelectField onEnter={onEnter} isMandatory={isMandatory} name={name} options={loading ? [] : getOptions()}
                         label={label} isMulti={false} onChange={onChange}/>
        )
    }
}

export default ApiTurnstileSelectField;
